// modules/estrategias/rbc/utils/handleDuplicado.js
// Reconstruido a partir de cómo lo usa DiscapacidadModal.js:
//   if (!manejarErrorDuplicado(error, "Discapacidad")) { ...mostrar error genérico... }
// Es decir: si el error ES un duplicado (409, codigo "DUPLICADO"), muestra
// su propio Swal y devuelve true (para que el catch no muestre el genérico
// encima). Si no es duplicado, devuelve false.

import Swal from "sweetalert2";

export function manejarErrorDuplicado(error, nombreModulo = "registro") {
  const data = error?.response?.data;
  if (error?.response?.status === 409 && data?.codigo === "DUPLICADO") {
    Swal.fire({
      icon: "warning",
      title: "Registro duplicado",
      text: data.message || `Ya existe un registro de ${nombreModulo} con ese documento.`,
      confirmButtonColor: "#d33",
    });
    return true;
  }
  return false;
}
